import { render, staticRenderFns } from "./ProjectSectionComponent.vue?vue&type=template&id=14865f94"
import script from "./ProjectSectionComponent.vue?vue&type=script&lang=js"
export * from "./ProjectSectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports